"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var native;
/**
 * Taking property descriptors for native implementations.
 */
function getNativeApi(key) {
    return Object.getOwnPropertyDescriptor(HTMLElement.prototype, key) ||
        Object.getOwnPropertyDescriptor(Object.getPrototypeOf(HTMLElement.prototype), key) ||
        Object.getOwnPropertyDescriptor(Element.prototype, key) ||
        Object.getOwnPropertyDescriptor(Object.getPrototypeOf(Element.prototype), key) || // ContainerNode is not exposed globally
        Object.getOwnPropertyDescriptor(Node.prototype, key);
}
// native api
exports.firstChildNative = getNativeApi('firstChild');
exports.lastChildNative = getNativeApi('lastChild');
exports.innerHTMLNative = getNativeApi('innerHTML');
exports.outerHTMLNative = getNativeApi('outerHTML');
exports.textContentNative = getNativeApi('textContent');
exports.childNodesNative = getNativeApi('childNodes');
exports.childrenNative = getNativeApi('children');
exports.parentNodeNative = getNativeApi('parentNode');
exports.parentElementNative = getNativeApi('parentElement');
exports.nextSiblingNative = getNativeApi('nextSibling');
exports.previousSiblingNative = getNativeApi('previousSibling');
exports.nextElementSiblingNative = getNativeApi('nextElementSibling');
exports.previousElementSiblingNative = getNativeApi('previousElementSibling');
exports.assignedSlotNative = getNativeApi('assignedSlot');
exports.removeNative = getNativeApi('remove');
/**
 * Enable or disable exposing native api
 */
function exposeNativeApi(expose) {
    native = expose;
}
exports.exposeNativeApi = exposeNativeApi;
/**
 * Check is native api exposed.
 */
function isNativeApiExposed() {
    return native;
}
exports.isNativeApiExposed = isNativeApiExposed;
